<template>
  <div class="mt-1 mb-3">
    <h3 class="mb-1 text-lg font-bold">{{ $t("settings.payment") }}</h3>
    <div class="flex h-[50px] items-center">
      <p class="w-1/3 text-base">
        {{ $t("button.complete-order-with-balance") }}
      </p>
      <div class="flex w-1/3 items-center gap-2">
        <SButton
          type="button"
          class="flex-1"
          :variant="status ? 'default' : 'outline'"
          @click="toggleStatus(true)"
        >
          {{ $t("button.enabled") }}
        </SButton>
        <SButton
          type="button"
          class="flex-1"
          :variant="!status ? 'default' : 'outline'"
          @click="toggleStatus(false)"
        >
          {{ $t("button.disabled") }}
        </SButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import POSConfigModule from "@/store/modules/pos-config";
import { SButton } from "@smeetz/ui-core";

export default defineComponent({
  name: "CompleteWithBalanceSettings",
  components: { SButton },
  setup() {
    const status = ref(POSConfigModule.completeBookingWithBalance);
    const toggleStatus = (newStatus: boolean) => {
      status.value = newStatus;
    };
    return {
      status,
      toggleStatus,
    };
  },
});
</script>
